import "@/App.css";
import "./i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { ValueProps, HowItWorks, Certifications } from "./components/Sections";
import { VideoShowcase } from "./components/VideoShowcase";
import { ProductsSection } from "./components/ProductsSection";
import { DosageTable } from "./components/DosageTable";
import { Testimonials } from "./components/Testimonials";
import { FAQSection } from "./components/FAQSection";
import { NewsletterFooter } from "./components/NewsletterFooter";
import { QuotationSection } from "./components/QuotationSection";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import { CartDrawer } from "./components/CartDrawer";
import CheckoutPage from "./pages/CheckoutPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import AdminPage from "./pages/AdminPage";
import OrderTrackingPage from "./pages/OrderTrackingPage";

const Home = () => (
  <>
    <Navbar />
    <Hero />
    <ValueProps />
    <VideoShowcase />
    <HowItWorks />
    <ProductsSection />
    <DosageTable />
    <Certifications />
    <Testimonials />
    <QuotationSection />
    <FAQSection />
    <NewsletterFooter />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/order/:orderId" element={<OrderTrackingPage />} />
          </Routes>
          <CartDrawer />
          <WhatsAppFloat />
          <Toaster position="top-center" richColors />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
